<template>
  <div class="dialog-center">
    <el-dialog title="发票信息" :visible.sync="visible" width="780px" :close-on-click-modal="false" :before-close="closeDialog">
      <div class="title">填写发票信息</div>
      <div class="form">
        <div class="title-top">注：单张发票金额上限10000元，超出金额将会被拆分多张发票</div>
        <el-form ref="form" :model="form" label-width="120px" :rules="rules">
          <div class="form-text">
            <!-- *经纪代理服务*国际货运代理费 -->
            <el-form-item label="发票内容" v-if="form.invoiceType == 1"> 技术服务费</el-form-item>
            <el-form-item label="发票内容" v-if="form.invoiceType == 2"> 技术服务费</el-form-item>
            <el-form-item label="发票金额">
              <span class="amount">￥{{ amount.toFixed(2) }}</span>
            </el-form-item>
            <el-form-item label="发票抬头">{{$store.getters.userData.companyName}}</el-form-item>
          </div>
          <el-form-item label="发票类型" prop="invoiceType">
            <el-radio-group v-model="form.invoiceType">
              <el-radio label="1">普通发票</el-radio>
              <!-- <el-radio label="2">增值税专票</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="taxNo">
            <el-input size="small" v-model.trim="form.taxNo" placeholder="请输入税号" type="text" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="收票人邮箱" prop="email">
            <el-input size="small" v-model.trim="form.email" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input size="small" v-model.trim="form.address" placeholder="请输入公司地址"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input size="small" v-model.trim="form.telephone" placeholder="请输入公司电话"></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="bank">
            <el-input size="small" v-model.trim="form.bank" placeholder="请输入开户行信息"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="bankAccount">
            <el-input size="small" v-model.trim="form.bankAccount" placeholder="请输入开票公司账号"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input size="small" v-model="form.remark" placeholder="备注内容将会打印在发票上，内容不超过120位字符，谨慎填写" type="textarea" maxlength="120"></el-input>
          </el-form-item>
          <div v-if="form.invoiceType == 2">
            <div class="dashed"></div>
            <div class="title">填写发票收件人信息</div>
          </div>
          <el-form-item label="地址" v-if="form.invoiceType == 2" required>
            <div style="">
              <regionSelect @getRegionData="getRegionData" :regionArr='regionArr' :type="3" :selectStyle="selectStyle"></regionSelect>
            </div>
          </el-form-item>
          <el-form-item label="详细地址" v-if="form.invoiceType == 2" prop="receiveAddress">
            <el-input size="small" v-model="form.receiveAddress"></el-input>
          </el-form-item>
          <el-form-item label="收件人电话" v-if="form.invoiceType == 2" prop="receiverPhone">
            <el-input size="small" v-model.trim="form.receiverPhone"></el-input>
          </el-form-item>
          <el-form-item label="收件人姓名" v-if="form.invoiceType == 2" prop="receiver">
            <el-input size="small" v-model="form.receiver"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeDialog">取消</el-button>
        <el-button size="mini" type="primary" :loading="loading" @click="onSubmit">确定提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax"
import { isEmail, isPhone, isTaxpayer } from "@/utils/util"
import regionSelect from "@/components/select/RegionSelect"
export default {
  name: "fillbill",
  props: {
    visible: Boolean,
    invoicingList: Array,
    amount: Number,
  },
  components: {
    regionSelect,
  },
  data () {
    let validateEmail = (rule, value, callback) => {
      if (!isEmail(value)) {
        callback(new Error("邮箱格式错误"))
      } else {
        callback()
      }
    }
    let validateTaxNo = (rule, value, callback) => {
      if (value.length < 15 || value.length > 20) {
        callback(new Error("纳税人识别号须为15位、18或者20位"))
      } else if (!isTaxpayer(value)) {
        callback(new Error("纳税人识别号格式错误"))
      } else {
        callback()
      }
    }
    let validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"))
      } else if (!isPhone(value)) {
        callback(new Error("手机号格式错误"))
      } else {
        callback()
      }
    }
    let checkTel = (rule, value, callback) => {
      var tel = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/ //  固定电话
      let pone = /^\d{11}$/          //  手机号
      if (tel.test(value) || pone.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的电话号码!'))
      }
    }
    return {
      form: {
        invoiceTitle: this.$store.getters.userData.companyName,
        invoiceType: "1",
        taxNo: "",
        address: "",
        telephone: "",
        bank: "",
        bankAccount: "",
        receiveAddress: "",
        receiverPhone: "",
        receiver: "",
      },
      selectStyle: 'width:100px !important',
      regionArr: [],  //地区数据
      rules: {
        invoiceType: [{ required: true, message: "请选择发票类型", trigger: "blur" },],
        taxNo: [
          {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur",
          },
          { min: 0, max: 20, validator: validateTaxNo, trigger: "blur" },
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        telephone: [
          { required: true, message: '请输入固定电话', trigger: 'blur' },
          { validator: checkTel, trigger: 'blur' },
        ],
        address: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        bank: [
          { required: true, message: "请输入开户行信息", trigger: "blur" },
        ],
        bankAccount: [
          { required: true, message: "请输入开票公司账号", trigger: "blur" },
        ],
        receiveAddress: [
          { required: true, message: "请输入收件人地址", trigger: "blur" },
        ],
        receiverPhone: [
          { required: true, message: "请输入收件人电话", trigger: "blur" },
        ],
        receiver: [
          { required: true, message: "请输入收件人姓名", trigger: "blur" },
        ],
      },
      loading: false,
    }
  },
  mounted () {
    // let userData = this.$store.getters.userData
    // this.form.email = userData.email
    // this.form.telephone = userData.phone
  },
  methods: {
    //获取地区选择组件的数据
    getRegionData (...data) {
      console.log(data)
      this.regionArr = data

      // this.form.receiveCountry = data[0]
      this.form.receiveProvince = data[1]
      this.form.receiveCity = data[2]
      this.form.receiveArea = data[3]

    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            orderNos: this.invoicingList,
            amount: this.amount,
            ...this.form
          }
          this.form.invoiceType = parseInt(this.form.invoiceType)
          this.loading = true
          httpAjax({
            url: "/services/invoice/apply",
            method: "post",
            data: params,
          }).then((response) => {
            this.loading = false
            if (response.success) {
              this.$message({
                message: "提交成功",
                type: "success",
              })
              this.closeDialog()
            } else {
              this.$message({
                message: response.reasonPhrase,
                type: "error",
              })
            }
          })
        } else {
          return false
        }
      })
      return
    },
    // 关闭
    closeDialog () {
      this.form = {
        invoiceTitle: this.$store.getters.userData.companyName,
        invoiceType: "1",
        taxNo: "",
        address: "",
        telephone: "",
        bank: "",
        bankAccount: "",
        receiveAddress: "",
        receiverPhone: "",
        receiver: "",
      }
      this.$parent.invoicingDialogVisible = false
      this.$parent.getData()
    },
  },
}
</script>

<style scoped lang="less">
.title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  margin-bottom: 16px;
}
::v-deep .el-input {
  width: 320px;
}
.form-text {
  background-color: #ecf1ff;
  margin: 16px 0;
  .amount {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
.form-content {
  width: 90%;
}
/deep/ .el-form-item {
  margin-bottom: 12px;
}

/deep/ .el-form-item__error {
  padding: 0;
  top: 33px;
}
.title-top {
  color: #1170eb;
  background: #ecf1ff;
  border-radius: 4px;
  border: 1px solid #1170eb;
  padding: 8px 10px;
}
.bill-amount {
  height: 64px;
  span {
    color: #eb5e00;
  }
  .remind {
    padding-left: 16px;
    font-size: 10px;
    color: #d90000;
    position: absolute;
    top: 24px;
    left: -88px;
  }
}
.dashed {
  width: 100%;
  border-bottom: 1px dashed #dedede;
  margin: 24px 0;
}
::v-deep .el-textarea__inner {
  width: 320px;
  height: 72px;
  overflow-y: auto;
  /* overflow-y: auto;兼容ie  */
}
</style>